
import { UpdateLogEntry, UserConfigLogEntry } from '@/api/dtos/LogEntry.schema'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class UserConfigLogEntryContent extends Vue {
  @Prop()
  logEntry!: UserConfigLogEntry
}
